import { render, staticRenderFns } from "./fwdakademo.vue?vue&type=template&id=79cbfa78&"
import script from "./fwdakademo.vue?vue&type=script&lang=js&"
export * from "./fwdakademo.vue?vue&type=script&lang=js&"
import style0 from "./fwdakademo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79cbfa78')) {
      api.createRecord('79cbfa78', component.options)
    } else {
      api.reload('79cbfa78', component.options)
    }
    module.hot.accept("./fwdakademo.vue?vue&type=template&id=79cbfa78&", function () {
      api.rerender('79cbfa78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/renwu/fwdakademo.vue"
export default component.exports